export default __webpack_public_path__ + "static/media/logo_mark.72caf2da.svg";